import { CONFIG, authHeaders, authFetch } from './config';

export class PaymentService {
  static async getSubscriptionProducts() {
    try {
      const response = await authFetch(`${CONFIG.BASE_URL}/subscription-products`, {
        method: 'GET',
        headers: authHeaders({
          'Content-Type': 'application/json',
        }),
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Erreur lors de la récupération des produits:', error);
      throw error;
    }
  }

  // static async initiatePayment(priceId, affiliateKey = null) {
  //   try {
  //     if (!this.isAuthenticated()) {
  //       throw new Error('Utilisateur non authentifié');
  //     }

  //     const token = localStorage.getItem('quikr_access_token') || 
  //                   this.getCookieValue('quikr_access_token');
      
  //     if (!token) {
  //       throw new Error('Token d\'authentification manquant');
  //     }

  //     const url = new URL(`${CONFIG.BASE_URL}/subscription-payment-page/${priceId}`);
  //     if (affiliateKey) {
  //       url.searchParams.append('affiliate_key', affiliateKey);
  //     }
      
  //     url.searchParams.append('token', token);
  //     window.location.href = url.toString();
      
  //     return { redirected: true };
  //   } catch (error) {
  //     console.error('Erreur lors de l\'initiation du paiement:', error);
  //     throw error;
  //   }
  // }

static async initiatePayment(priceId, affiliateKey = null) {
  if (!this.isAuthenticated()) throw new Error('Utilisateur non authentifié');

  const url = new URL(`${CONFIG.BASE_URL}/subscription-payment-page/${priceId}`);
  if (affiliateKey) url.searchParams.append('affiliate_key', affiliateKey);

  const res = await authFetch(url.toString(), {
    method: 'GET',
    headers: authHeaders(),        
    credentials: 'include',
  });

  if (res.ok) {
    const data = await res.json();
    if (data.url) {
      window.location.href = data.url;
      return;
    }
  }
  // if (res.status === 302 || res.status === 303) {
  //   const stripeUrl = res.headers.get('Location');
  //   console.log(stripeUrl)
  //   if (stripeUrl) {
  //     window.location.href = stripeUrl;         
  //     return;
  //   }
  // }
  throw new Error(`Paiement impossible (code ${res.status})`);
}

  static isAuthenticated() {
    const token =
      localStorage.getItem('quikr_access_token') ||
      this.getCookieValue('quikr_access_token');
    const emailVerified = localStorage.getItem('quikr_email_verified') === 'true';
    return Boolean(token && emailVerified);
  }


  static getCookieValue(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }


  static formatPrice(unitAmount) {
    if (unitAmount === 0) return 'Gratuit';
    return `${(unitAmount / 100).toFixed(2)}€`;
  }

  static mapStripeProducts(stripeProducts) {
    const productMapping = {
      'Free plan': 'free',
      'Basic plan': 'basic', 
      'Clever plan': 'clever',
      'Premium plan': 'premium'
    };

    return stripeProducts.map(product => ({
      id: productMapping[product.item.name] || product.item.id,
      stripeProductId: product.item.id,
      stripePriceId: product.price.id,
      name: product.item.name,
      description: product.item.description,
      price: product.price.unit_amount,
      currency: product.price.currency,
      interval: product.price.recurring?.interval || 'month',
      nickname: product.price.nickname,
      active: product.item.active && product.price.active
    }));
  }
}
